/* global axios */
import ApiClient from './ApiClient';

class TramitesAPI extends ApiClient {
  constructor() {
    super('tramites', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(tramiteData) {
    return axios.post(this.url, { tramite: tramiteData });
  }

  update(id, tramiteData) {
    return axios.patch(`${this.url}/${id}`, { tramite: tramiteData });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  meta() {
    return axios.get(`${this.url}/meta`);
  }

  board(params = {}) {
    return axios.get(`${this.url}/board`, { params });
  }

  assign(id, assigneeId) {
    return axios.post(`${this.url}/${id}/assign`, { assignee_id: assigneeId });
  }

  // NOTE: the backend param is `action_name` (not `action`).
  advanceStage(id, { actionName, comment } = {}) {
    return axios.post(`${this.url}/${id}/advance_stage`, {
      action_name: actionName,
      comment,
    });
  }

  submit(id) {
    return axios.post(`${this.url}/${id}/submit`);
  }

  // Records a manual payment outcome (status: 'paid' | 'waived' | 'pending'). The future payment
  // gateway webhook hits the same backend service with a transaction reference.
  recordPayment(id, { status, reference, amount } = {}) {
    return axios.post(`${this.url}/${id}/record_payment`, {
      status,
      reference,
      amount,
    });
  }

  updateCustomAttributes(id, customAttributes) {
    return axios.post(`${this.url}/${id}/update_custom_attributes`, {
      custom_attributes: customAttributes,
    });
  }

  // Issues (idempotent) the public document-request share token for the tramite.
  createDocumentRequestShare(id) {
    return axios.post(`${this.url}/${id}/document_request_share`);
  }

  // Revokes the public document-request share token for the tramite.
  revokeDocumentRequestShare(id) {
    return axios.delete(`${this.url}/${id}/document_request_share`);
  }

  // Stages (nested)
  getStages(id) {
    return axios.get(`${this.url}/${id}/stages`);
  }

  // Timeline (activity + comments rows)
  timeline(id) {
    return axios.get(`${this.url}/${id}/timeline`);
  }

  // Comments (nested)
  getComments(id) {
    return axios.get(`${this.url}/${id}/comments`);
  }

  createComment(id, { message, isPrivate = false, clientVisible = false } = {}) {
    return axios.post(`${this.url}/${id}/comments`, {
      comment: {
        message,
        private: isPrivate,
        client_visible: clientVisible,
      },
    });
  }
}

export default new TramitesAPI();
